import BaseSlotSymbol from "Engine/slots/symbols/BaseSlotSymbol";

export default class Symbol extends BaseSlotSymbol {
    constructor(data, displayItemData) {
        super(data, displayItemData);
    }

    createTweens() {

    }

    changeSymbol(id) {
        super.changeSymbol(id);
        this.stopAnimation();
    }

    startAnimation(min = false) {
        this.image = this.getChildAt(0);
        this.image.visible = false;
    }

    stopAnimation() {
        this.image.visible = true;
    }
}
